<form [formGroup]="loginForm" class="pb-10">
  <p class="text-center font-bold text-lg">Entrar como</p>
  <div class="block">
    <!--    <div class="floating-select-container pb-1">-->
    <!--      <select id="options" formControlName="userType" required>-->
    <!--        @for (type of typeList; track type.id) {-->
    <!--          <option [value]="type.id">{{ type.name }}</option>-->
    <!--        }-->
    <!--      </select>-->
    <!--      <label for="options">Opções</label>-->
    <!--      <mat-icon fontIcon="arrow_drop_down"/>-->
    <!--    </div>-->

    <div class="flex flex-col gap-4">
      <mat-form-field
        class="input-tg w-full"
        appearance="outline"
        hideRequiredMarker="true"
      >
        <mat-label>Email</mat-label>
        <input id="email" type="email" matInput formControlName="email" />
      </mat-form-field>
      <mat-form-field
        class="input-tg w-full"
        appearance="outline"
        hideRequiredMarker="true"
      >
        <mat-label>Senha</mat-label>
        <input
          id="password"
          type="password"
          matInput
          formControlName="password"
        />
      </mat-form-field>
    </div>

    <div class="flex justify-end">
      <!--      <div class="flex align-bottom cursor-pointer" (click)="rememberAccess = !rememberAccess">-->
      <!--        @if (rememberAccess) {-->
      <!--          <mat-icon class="color-tg" fontIcon="check_box"/>-->
      <!--        } @else {-->
      <!--          <mat-icon class="color-tg" fontIcon="check_box_outline_blank"/>-->
      <!--        }-->
      <!--        <div class="ml-1 pt-0.5">-->
      <!--          Lembrar senha-->
      <!--        </div>-->
      <!--      </div>-->
      <div class="text-end">
        <a class="link-tg cursor-pointer" (click)="forgotPass()">
          Esqueceu a senha?
        </a>
      </div>
    </div>
    <button
      mat-flat-button
      class="btn-tg w-full mt-6"
      [disabled]="!checkForm() || loading"
      (click)="sendLogin()"
    >
      @if (loading) {
        <mat-spinner
          diameter="22"
          class="loading-spinner"
          selected-track-color="red"
        ></mat-spinner>
      } @else {
        Entrar
      }
    </button>
  </div>
</form>
